import React from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import "../Styles/_OrderPopupSimpleWindow.css";

const ConfirmationWindow = ({ open, handleClose, handleSubmit, heading, subheading, noText, yesText, loading }) => {
    return (
        <Dialog
            className="popup-simple-window-dialog"
            classes={{ paper: "popup-simple-window-dialog-paper" }}
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="simple-dialog-title"
            open={open || false}
        >
            <div className="layout vertical popup-simple-window">
                <div className="flex layout horizontal end-justified">
                    <CloseIcon className="layout vertical center-center close-corner-button" onClick={handleClose} />
                </div>
                <div className="flex layout vertical relative">
                    <div className="layout vertical popup-simple-window-inner">
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <p className="layout vertical center-center title">{heading}</p>
                                </div>
                            </div>
                        </div>

                        <div className="box" style={{ margin: "20px 0px" }}>
                            <div className="row">
                                <div className="column">
                                    <div className="sub-title">{subheading}</div>
                                </div>
                            </div>
                        </div>
                        <div className="box" style={{ margin: "20px 0px" }}>
                            <div className="row">
                                <div className="column">
                                    <div className="flex layout dynamic-direction-mobile-portrait">
                                        <div className="flex layout vertical">
                                            {noText && (
                                                <button className="custom-button negative" onClick={handleClose}>
                                                    <div className="layout vertical center-center inbutton-text">{noText}</div>
                                                </button>
                                            )}
                                        </div>
                                        <div className="flex layout vertical">
                                            {yesText && (
                                                <button
                                                    className={`custom-button ${loading ? "loading" : ""}`}
                                                    style={{ float: "right" }}
                                                    onClick={loading ? null : handleSubmit}
                                                >
                                                    <div className="layout vertical center-center inbutton-text">{yesText}</div>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default withRouter(ConfirmationWindow);
